import { NotImplementedView } from "~/src/views/fragments/not-implemented";

export const AuthorizeView = () => {
  return <NotImplementedView />;
};
